// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__17oIy","inputWrap":"styles_inputWrap__oxR4Z","input":"styles_input__2nmll"};